import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { RecurringPayment } from 'actions/actionTypes';
import * as actions from 'actions/billing/recurringPayment';

import { changeIsRecurringPayment } from 'actions/common/billing';

import { 
    callShopRecurringPayment, 
    callShopPaymentMethod, 
    callShopPaymentMethodAdd, 
    callShopPaymentMethodDelete,
    callShopRecurringPaymentCancel,
    callRecurringPayment, 
    callMyBankAcccountPaymentApprovalRequest, 
    callCreditCardPaymentVerifyRequest 
} from 'network/apis/billing/recurringPayment';

import History from 'routes/history';

import texts from 'assets/locale/texts';

function* loadShopRecurringPaymentRequestSaga() {
    try {
        const response = yield call(callShopRecurringPayment);

        yield put(actions.loadShopRecurringPaymentSuccess(response.data));

        yield put(changeIsRecurringPayment(response.data.isUseRecurringPayment));
    } catch(error) {
        yield put(actions.loadShopRecurringPaymentFailure(error.message));
    }
}

function* loadShopPaymentMethodRequestSaga() {
    try {
        const response = yield call(callShopPaymentMethod);

        yield put(actions.loadShopPaymentMethodSuccess(response.data));
    } catch(error) {
        yield put(actions.loadShopPaymentMethodFailure(error.message));
    }
}

function* addShopPaymentMethodRequestSaga() {
    try {
        const recurringPayment = yield select(state => state.recurringPayment);

        const response1 = yield call(callShopPaymentMethodAdd, recurringPayment.addPaymentMethodType);

        const response2 = yield call(callRecurringPayment, response1.data.paymentGatewayUrl);

        yield put(actions.addShopPaymentMethodSuccess(response2.data));
    } catch(error) {
        yield put(actions.addShopPaymentMethodFailure(error.message));
    }
}

function* deleteShopPaymentMethodRequestSaga() {
    try {
        const recurringPayment = yield select(state => state.recurringPayment);
        const language = yield select(state => state.language);

        const response = yield call(callShopPaymentMethodDelete, recurringPayment.deletePaymentMethodIdx);

        const text = texts[language.currentLanguage];

        if(response.status === 200){
            alert(text.alert.deletePaymentMethodSuccess);
        }
        else{
            alert(text.alert.deletePaymentMethodFail);
        }

        yield put(actions.deleteShopPaymentMethodSuccess(response.data));

        yield put(actions.loadShopRecurringPaymentRequest());
        yield put(actions.loadShopPaymentMethodRequest());
    } catch(error) {
        yield put(actions.deleteShopPaymentMethodFailure(error.message));
    }
}

function* shopRecurringPaymentCancelRequestSaga() {
    try {
        const language = yield select(state => state.language);

        const response = yield call(callShopRecurringPaymentCancel);

        const text = texts[language.currentLanguage];

        if(response.status === 200){
            alert(text.alert.shopRecurringPaymentCancelSuccess);

            yield put(changeIsRecurringPayment(false));
        }
        else{
            alert(text.alert.shopRecurringPaymentCancelFail);
        }

        yield put(actions.shopRecurringPaymentCancelSuccess(response.data));
    } catch(error) {
        yield put(actions.shopRecurringPaymentCancelFailure(error.message));
    }
}

function* myBankAccountPaymentApprovalRequestSaga() {
    try {
        const recurringPayment = yield select(state => state.recurringPayment);

        const response = yield call(callMyBankAcccountPaymentApprovalRequest, recurringPayment.paymentApprovalToken);

        if(response.status === 200){
            if(response.data.isPaymentApproval === true){
                History.push('/payment/complete');
            }
            else{
                History.push('/payment/fail');
            }
        }
        else{
            History.push('/payment/fail');
        }

    } catch(error) {
        yield put(actions.myBankAccountPaymentApprovalFailure(error.message));
    }
}

function* creditCardPaymentVerifyRequestSaga() {
    try {
        const recurringPayment = yield select(state => state.recurringPayment);

        const response = yield call(callCreditCardPaymentVerifyRequest, recurringPayment.paymentVerifyToken);

        if(response.status === 200){
            if(response.data.isPaymentVerify === true){
                History.push('/payment/complete');
            }
            else{
                History.push('/payment/fail');
            }
        }
        else{
            History.push('/payment/fail');
        }
    } catch(error) {
        yield put(actions.creditCardPaymentVerifyFailure(error.message));
    }
}

// Sign-In Sagas
export default function* root() {
    yield all([
        takeLatest(RecurringPayment.LOAD_SHOP_RECURRING_PAYMENT_REQUEST, loadShopRecurringPaymentRequestSaga),
        takeLatest(RecurringPayment.LOAD_SHOP_PAYMENT_METHOD_REQUEST, loadShopPaymentMethodRequestSaga),
        takeLatest(RecurringPayment.ADD_SHOP_PAYMENT_METHOD_REQUEST, addShopPaymentMethodRequestSaga),
        takeLatest(RecurringPayment.DELETE_SHOP_PAYMENT_METHOD_REQUEST, deleteShopPaymentMethodRequestSaga),
        takeLatest(RecurringPayment.SHOP_RECURRING_PAYMENT_CANCEL_REQUEST, shopRecurringPaymentCancelRequestSaga),
        takeLatest(RecurringPayment.MY_BANK_ACCOUNT_PAYMENT_APPROVAL_REQUEST, myBankAccountPaymentApprovalRequestSaga),
        takeLatest(RecurringPayment.CREDIT_CARD_PAYMENT_VERIFY_REQUEST, creditCardPaymentVerifyRequestSaga),
    ]);
}